import { apiFetch } from './client'
import { cached, invalidate } from './cache'

export interface Device {
  id: string
  name: string
  host: string
  port: number
  status: string
  last_seen_at?: string
  branch_id?: string
  zone_id?: string
}

export interface ScannedDevice {
  host: string
  port: number
  registered: boolean
  deviceId: string | null
  deviceName: string | null
}

export const getDevices = () =>
  cached('devices', () => apiFetch<{ devices: Device[] }>('/devices'), 120_000)

export const getDevice = (id: string) =>
  apiFetch<{ device: Device }>(`/devices/${id}`)

export const createDevice = async (input: {
  name: string
  host: string
  port: number
  username: string
  password: string
}) => {
  const r = await apiFetch<{ device: Device }>('/devices', { method: 'POST', body: JSON.stringify(input) })
  invalidate('devices')
  return r
}

export const updateDevice = async (id: string, input: {
  name?: string
  host?: string
  port?: number
  username?: string
  password?: string
}) => {
  const r = await apiFetch<{ device: Device }>(`/devices/${id}`, { method: 'PATCH', body: JSON.stringify(input) })
  invalidate('devices')
  return r
}

export const deleteDevice = async (id: string) => {
  const r = await apiFetch<{ success: boolean }>(`/devices/${id}`, { method: 'DELETE' })
  invalidate('devices')
  return r
}

export interface DeviceEnrollment {
  id: string
  user_id: string
  user_name: string
  employee_no: string
  user_type: string
  enrolled_at: string
  status: 'pending' | 'active' | 'blocked'
}

export const getDeviceEnrollments = (deviceId: string) =>
  apiFetch<{ enrollments: DeviceEnrollment[] }>(`/devices/${deviceId}/enrollments`)

export const enrollUsersToDevice = (deviceId: string, userIds: string[]) =>
  apiFetch<{ enrolled: Array<{ userId: string; enrollmentId: string }>; count: number }>(
    `/devices/${deviceId}/enroll-users`,
    { method: 'POST', body: JSON.stringify({ userIds }) }
  )

export const syncAllUsersToDevice = (deviceId: string) =>
  apiFetch<{ enrolled: number }>(`/devices/${deviceId}/sync-all-users`, { method: 'POST' })

export const scanDevices = (proxyUrl: string, proxyToken: string, subnet?: string) => {
  const qs = subnet ? `?subnet=${encodeURIComponent(subnet)}` : ''
  return fetch(`${proxyUrl}/devices/scan${qs}`, {
    headers: { Authorization: `Bearer ${proxyToken}` },
  }).then((r) => r.json() as Promise<{ subnets: string[]; devices: ScannedDevice[] }>)
}
